import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileTreeNode } from '../../interfaces/tree-node.interface';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-file-manager-grid',
  templateUrl: './file-manager-grid.component.html',
  styleUrls: ['./file-manager-grid.component.scss']
})
export class FileManagerGridComponent {
  @Output() navigateDown = new EventEmitter<FileTreeNode>;
  @Output() navigateUp = new EventEmitter();
  @Output() uploadFile = new EventEmitter();
  @Output() removeFile = new EventEmitter<FileTreeNode>;
  @Output() previewFile = new EventEmitter<FileTreeNode>;
  @Output() cancelSignFile = new EventEmitter<FileTreeNode>;
  @Output() newDocument = new EventEmitter();
  @Input() folderTreeNode: FileTreeNode;
  @Input() canNavigatePrev: boolean = false;
  @Input() path: string;
  @Input() noContentMessage: string = 'Sin archivos que mostrar'
  isGridView: boolean = true;

  toggleView() {
    this.isGridView = !this.isGridView;
  }

  navigateTo(element: FileTreeNode) {
    console.log(element);
    if(element.isFolder){
      this.navigateDown.emit(element);
    } else {
      this.previewFile.emit(element);
    }
  }

  openPreviewDocument(element: FileTreeNode) {
    this.previewFile.emit(element);
  }

  navigatePrev() {
    this.navigateUp.emit();
  }

  openUploadNewFile() {
    this.uploadFile.emit();
  }

  openNewDocuemnt() {
    this.newDocument.emit();
  }

  deleteFile(element: FileTreeNode) {
    this.removeFile.emit(element);
  }

  clickCancelFileSign(element : FileTreeNode) {
    this.cancelSignFile.emit(element);
  }

  openMenu(event: MouseEvent, element: FileTreeNode, viewChild: MatMenuTrigger) {
    event.preventDefault();
    if(element.isFolder) return;
    viewChild.openMenu();
  }

}